import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Components
import AdminCategorySortList from './AdminCategorySortList'

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'

// CSS
import '../../../css/sortable.css'

class AdminCategorySort extends Component {
    constructor(props) {
        super(props)
        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Set Category Order')
    }
    
    render() {
        return (
            <div>
                {!this.props.match.params.permalink && <h1>Set Category Order</h1>}

                <div className="margin_bottom">
                    Drag and drop the various categories you have and hit "Submit" when complete!
                </div>

                <Switch>
                    <Route path={'/admin/categories/sort/:permalink?'} component={AdminCategorySortList} />
                </Switch>
            </div>
        )
    }
}

export default connect(null, { addRoute, setpageTitle })(AdminCategorySort)



// WEBPACK FOOTER //
// ./src/components/admin/categories-sort/AdminCategorySort.js